<template>
  <div class="manage_center_wrap">
    <div class="custom_breadcrumb flex-rowl">
      <p>Home</p>
      <span class="iconfont icon-arrow"></span>
      <p>Business Management</p>
    </div>
    <div class="manage_center_container flex-rowl">
      <div class="menu_container">
        <div class="menu_wrap">
          <div
            class="menu_item flex-rowl"
            :class="{ active: item.active }"
            v-for="(item, index) in menuList"
            :key="index"
            @click="handleMenuItem(item)"
          >
            <span class="iconfont icon-yuyinjiantou" v-if="item.active"></span>
            <div
              class="icon flex-rowl"
              :style="{ width: item.w, height: item.h }"
            >
              <el-image
                style="width: 100%; height: 100%"
                :src="item.icon"
                fit="cover"
              ></el-image>
            </div>
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
      <div class="manage_container">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "manageCenterIndex",
  data() {
    return {
      // 导航菜单
      menuList: [
        {
          title: "订单管理",
          name: "orderList",
          // 图标
          icon: require("@/assets/images/manage_center_icon_dingdan.png"),
          active: false,
          w: "18px",
          h: "20px",
        },
        {
          title: "选款推荐(推荐商品示例)",
          name: "selectMsgList",
          // 图标
          icon: require("@/assets/images/manage_center_icon_xuankuan.png"),
          active: false,
          w: "20px",
          h: "20px",
        },
        {
          title: "收货信息管理",
          name: "receivingInfo",
          // 图标
          icon: require("@/assets/images/manage_center_icon_shouhuo.png"),
          active: false,
          w: "21px",
          h: "20px",
        },
        {
          title: "仓库信息管理",
          name: "warehouseInfo",
          // 图标
          icon: require("@/assets/images/manage_center_icon_cangku.png"),
          active: false,
          w: "21px",
          h: "21px",
        },

        
        {
          title: "业务管理",
          name: "userManagement",
          // 图标
          icon: require("@/assets/images/manage_center_icon_xinxi.png"),
          active: false,
          w: "19px",
          h: "20px",
        },
      ],
    };
  },
  watch: {
    $route() {
      this.getActiveIndex();
    },
  },
  mounted() {
    this.getActiveIndex();
  },
  methods: {
    // 根据路由中name的值，获取当前的菜单索引
    getActiveIndex() {
      this.menuList.forEach((item) => {
        if (item.name === this.$route.name) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
    },
    handleMenuItem(item) {
      if (item.name != "") {
        this.$router.push({ name: item.name });
        this.menuList.forEach((v) => {
          if (v.name === item.name) {
            v.active = true;
          } else {
            v.active = false;
          }
        });
      } else {
        this.$message.warning("即将开放");
      }
    },
  },
};
</script>
  <style lang="less">
.manage_center_wrap {
  height: calc(100vh - 90px);
  padding-top: 140px;
  box-sizing: border-box;
  background: #e7e8f0;
  .custom_breadcrumb {
    height: 60px;
    background: #fff;
    padding-left: 70px;
    box-sizing: border-box;
    margin-bottom: 20px;
    position: fixed;
    left: 0;
    right: 0;
    top: 60px;
    z-index: 1001;
    p {
      font-size: 16px;
      color: #2c2c2c;
      font-weight: bold;
      cursor: pointer;
    }
    span {
      margin: 0 10px;
      transform: rotate(180deg);
    }
  }
  .manage_center_container {
    align-items: flex-start;
    .menu_container {
      height: 100%;
      width: 300px;
      margin-right: 30px;
      z-index: 1000;
      .menu_wrap {
        position: fixed;
        left: 0;
        width: 300px;
        top: 140px;
        background: #fff;
        .menu_item {
          line-height: 50px;
          font-size: 16px;
          color: #333333;
          cursor: pointer;
          position: relative;
          border-bottom: 1px solid rgba(84, 79, 90, 0.05);
          padding-left: 65px;
          box-sizing: border-box;
          &.active::after {
            width: 10px;
            height: 100%;
            background: #000000;
            content: "";
            position: absolute;
            right: -10px;
            top: 0;
          }
          .icon {
            width: 21px;
            margin-right: 14px;
            vertical-align: middle;
          }
          .icon-yuyinjiantou {
            position: absolute;
            left: 20px;
            transform: rotate(-90deg);
          }
        }
      }
    }
    .manage_container {
      // min-height: 65vh;
      width: 1300px;
      box-sizing: border-box;
      .breadcrumb1 {
        font-size: 16px;
        color: #999999;
      }
      .manage_operate {
        box-sizing: border-box;
        font-size: 18px;
        .operate_add {
          background: #000000;
          color: #fff;
          margin-right: 10px;
          padding: 0 30px;
          box-sizing: border-box;
          height: 50px;
          width: 200px;
          cursor: pointer;
          position: relative;
          .iconfont {
            position: absolute;
            left: 20px;
          }
        }
        .operate_edit {
          color: #333333;
          border: 1px solid #000000;
          padding: 0 30px;
          box-sizing: border-box;
          border-radius: 4px;
          height: 40px;
          line-height: 40px;
          cursor: pointer;
        }
      }

      .custom-button {
        background: #000000;
        border: none;
      }

      .fade-enter-active,
      .fade-leave-active {
        transition: opacity 0.5s;
      }
      .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
      }

      .el-dialog__header,
      .el-dialog__footer {
        background: #f7f8fa;
      }
    }
  }
}
</style>